import styles from "./WhatToxboxBestChatbot.module.css";
import customerSupportImg from "../../../Images/6o827y4z.png";
import {
    Bot,
    MessageCircle,
    FileText,
    Sparkles,
    Code2,
    CheckCircle
} from "lucide-react";

const WhatToxboxBestChatbot = () => {
    return (
        <section className={styles.section}>
            {/* Heading */}
            <h2 className={styles.title}>What ToxboxAI Does Best</h2>

            {/* Cards Grid */}
            <div className={styles.grid}>
                <div className={styles.card}>
                    <div className={`${styles.icon} ${styles.blue}`}>
                        <Bot />
                    </div>
                    <h4>AI Agent Builder</h4>
                    <p>
                        Train your chatbot using website pages, FAQs, PDFs, or internal
                        knowledge. Control how it thinks, talks, and responds.
                    </p>
                </div>

                <div className={styles.card}>
                    <div className={`${styles.icon} ${styles.green}`}>
                        <MessageCircle />
                    </div>
                    <h4>Instant Answers</h4>
                    <p>
                        Pricing, policies, product details, availability — answered
                        immediately. No tickets. No waiting.
                    </p>
                </div>

                <div className={styles.card}>
                    <div className={`${styles.icon} ${styles.purple}`}>
                        <FileText />
                    </div>
                    <h4>Smart Form Completion</h4>
                    <p>
                        Users hate forms. ToxboxAI turns them into conversations — reducing
                        drop-offs and increasing submissions.
                    </p>
                </div>

                <div className={styles.card}>
                    <div className={`${styles.icon} ${styles.pink}`}>
                        <Sparkles />
                    </div>
                    <h4>Brand-Matched Experience</h4>
                    <p>
                        Customize colors, tone, and behavior so the chatbot feels native to
                        your website.
                    </p>
                </div>

                <div className={styles.card}>
                    <div className={`${styles.icon} ${styles.orange}`}>
                        <Code2 />
                    </div>
                    <h4>Embed Anywhere</h4>
                    <p>One embed code. Any page. Works everywhere.</p>
                </div>

                <div className={`${styles.card} ${styles.gradientCard}`}>
                    <div className={styles.gradientIcon}>
                        <CheckCircle />
                    </div>
                    <h4>Launch in Minutes</h4>
                    <p>
                        Get your AI chatbot live on your website faster than you can make a
                        cup of coffee.
                    </p>
                </div>
            </div>

            {/* Bottom Content */}
            <div className={styles.bottom}>
                <img
                    src={customerSupportImg}
                    alt="Customer support"
                    className={styles.image}
                />
                <div className={styles.text}>
                    <h3>Built for real conversations, not canned <br />
                        responses</h3>
                    <p>
                        ToxboxAI understands context, remembers what users said, and <br />
                        guides
                        them to the right action — whether that's making a purchase,<br />
                        booking
                        a call, or filling out a form.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default WhatToxboxBestChatbot;